import type { RouteRecordRaw } from 'vue-router'
import homePageRoutes from './homePageRoutes'

const routes: RouteRecordRaw[] = [
  {
    name: 'layout',
    path: '/',
    redirect: '/dashboard',
    component: () => import('@/layout/index.vue'),
    children: homePageRoutes
  },
  {
    name: 'login',
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/:pathMatch(.*)*',
    meta: { title: '访问的页面不存在' },
    component: () => import('@/layout/404.vue')
  }
]

export default routes
